import * as _ from 'underscore';

export module QueryParameterHelper {
  export function urlWithParams(url: string, params: any): string {
    const pairs = _.map(params, (value: string, key: string) => {
      return encodeUriQuery(key, true) + '=' + encodeUriQuery(value, true);
    });
    if (pairs.length > 0) {
      const urlFragments = url.split('#');
      const separator = (urlFragments[urlFragments.length-1].indexOf('?') >= 0) ? '&' : '?';
      const paramsString = pairs.join('&');
      return url + separator + paramsString;
    } else {
      return url;
    }
  }
}

// This is copied from angular.js. Location.search uses this function instead of just encodeURIComponent which was
// causing extra entries in the history and preventing a user from using back properly- TFSID
function encodeUriQuery(val: string, pctEncodeSpaces?: boolean) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

export function encodeUriQueryExceptForSlashes(val: string) {
  return encodeUriQuery(val).
             replace(/%2F/gi, '/');
}
